export default {
  endpoint: "wss://kusama.rpc.robonomics.network/",
  isDevelopmentAccounts: false,
  subscription: "4GgRRojuoQwKCZP9wkB69ZxJY4JprmHtpzEzqJLjnqu4jk1r",
  stream:
    "https://www.youtube.com/embed/live_stream?channel=UCrSiho1uB-1n6F8cZpCLhjQ&autoplay=1&mute=0&controls=0",
  discord: "https://discord.gg/xqDgG3EGm9"
};
